
import PiecemealLoader from '../piecemeal-loader.js';
import Request from '../request.js';


(function(window, jQuery) {
  var lessonStarted = function() {
    // the back-end passes this query parameter when a lesson has been started
    if (Request.getParameterByName('cs-analytics-lesson-started')) {
      var properties;

      // the name of the lesson should be embedded within the article object.
      if (window.articleAnalytics) {
        properties = {
          'lesson_name': window.articleAnalytics.content_title
        };
      }

      window.CSAnalytics('Lesson Started', properties);
    }
  };

  var lessonComplete = function() {
    // the back-end passes this query parameter when a lesson has been completed
    if (Request.getParameterByName('cs-analytics-lesson-complete')) {
      var properties;

      // the name of the lesson should be embedded within the article object.
      if (window.articleAnalytics) {
        properties = {
          'lesson_name': window.articleAnalytics.content_title
        };
      }

      window.CSAnalytics('Lesson Finished', properties);
    }
  };

  var quizStarted = function() {
    var quizStart = jQuery('article.sfwd-quiz input[name="startQuiz"]');

    if (quizStart.length) {
      quizStart.on('click', function() {
        var properties;

        // the name of the quiz should be embedded within the article object.
        if (window.articleAnalytics) {
          properties = {
            'quiz_name': window.articleAnalytics.content_title
          };
        }

        window.CSAnalytics('Quiz Started', properties);
      });
    }
  };

  /**
   * A custom event is triggered when a quiz is finished.
   */
  var quizFinished = function() {
    var quiz = jQuery('article.sfwd-quiz .wpProQuiz_content');

    if (quiz.length) {
      quiz.on('learndash-quiz-finished', function() {
        var properties;

        // the name of the quiz should be embedded within the article object.
        if (window.articleAnalytics) {
          properties = {
            'quiz_name': window.articleAnalytics.content_title
          };
        }

        window.CSAnalytics('Quiz Finished', properties);
      });
    }
  };

  jQuery(function() {
    var loader = new PiecemealLoader([
      lessonStarted,
      lessonComplete,
      quizStarted,
      quizFinished
    ]);
    loader.initialise();
  });
})(window, jQuery);

